module.exports = __webpack_public_path__ + "img/media-header-img.3f4ec297.jpg";